import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import TianlanStoreSwitcher from './TianlanStoreSwitcher';
import { getStoredShop } from '../../utils/tianlanStore';

const NAV_ITEMS = [
  { to: '/exchange/tianlan', label: '總覽', exact: true },
  { to: '/exchange/tianlan/products', label: '商品規則' },
  { to: '/exchange/tianlan/orders', label: '訂單處理' },
  { to: '/exchange/tianlan/settings', label: '客人頁面' },
  { to: '/exchange/tianlan/stores', label: '直播商店' },
];

const PAGE_META = {
  '/exchange/tianlan': ['管理總覽', '售後服務'],
  '/exchange/tianlan/products': ['商品規則管理', '商品規則'],
  '/exchange/tianlan/orders': ['訂單售後服務後台', '訂單處理'],
  '/exchange/tianlan/settings': ['換貨處理與客人頁面', '系統設定'],
  '/exchange/tianlan/stores': ['直播商店管理', '商店'],
};

function TianlanAdminShell({ children, onLogout }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const currentShop = getStoredShop();
  const [title, eyebrow] = PAGE_META[location.pathname] || PAGE_META['/exchange/tianlan'];

  const isActive = (item) => (
    item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to)
  );

  return (
    <div className="tl-clarity-shell" data-design="clarity-a">
      <aside className={`tl-clarity-sidebar ${menuOpen ? 'is-open' : ''}`} aria-label="售後服務管理選單">
        <Link className="tl-clarity-brand" to="/exchange/tianlan" onClick={() => setMenuOpen(false)}>
          <span className="tl-clarity-brand-mark" aria-hidden="true">天</span>
          <span>
            <strong>售後服務</strong>
            <small>管理後台</small>
          </span>
        </Link>

        <div className="tl-clarity-nav-label">管理</div>
        <nav className="tl-clarity-nav">
          {NAV_ITEMS.slice(0, 4).map((item) => (
            <Link
              key={item.to}
              className={isActive(item) ? 'active' : ''}
              to={item.to}
              aria-current={isActive(item) ? 'page' : undefined}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="tl-clarity-nav-label">商店</div>
        <nav className="tl-clarity-nav">
          <Link
            className={isActive(NAV_ITEMS[4]) ? 'active' : ''}
            to={NAV_ITEMS[4].to}
            aria-current={isActive(NAV_ITEMS[4]) ? 'page' : undefined}
            onClick={() => setMenuOpen(false)}
          >
            {NAV_ITEMS[4].label}
          </Link>
          <a href="/tianlan/customer" target="_blank" rel="noopener noreferrer">開啟客人頁 ↗</a>
        </nav>

        <div className="tl-clarity-sidebar-foot">
          <span>目前商店</span>
          <strong>{currentShop.storeName}</strong>
          <small>{currentShop.shopUserId}</small>
        </div>
      </aside>

      {menuOpen && (
        <button
          type="button"
          className="tl-clarity-scrim"
          aria-label="關閉選單"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <div className="tl-clarity-main">
        <header className="tl-clarity-topbar">
          <button
            type="button"
            className="tl-clarity-menu-button"
            aria-label="開啟選單"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
          </button>
          <div className="tl-clarity-page-title">
            <span>{eyebrow}</span>
            <h1>{title}</h1>
          </div>
          <div className="tl-clarity-top-actions">
            <TianlanStoreSwitcher compact />
            <a className="tl-clarity-customer-link" href="/tianlan/customer" target="_blank" rel="noopener noreferrer">
              客人頁
            </a>
            {onLogout && (
              <button type="button" className="tl-clarity-logout" onClick={onLogout}>登出</button>
            )}
          </div>
        </header>
        <main className="tl-clarity-content">{children}</main>
      </div>
    </div>
  );
}

export default TianlanAdminShell;
